export default "__VITE_ASSET__DqfEhU99__"